import React, { FC, useContext, useState } from 'react';
import { Carousel, Drawer, Image, Layout, Row, Typography } from 'antd';
import { COYOTE_ORANGE, MURPLE_COLOR } from './util/Constants';
import { Main } from './Main';
import './App.less';
import { MenuComponent } from './components/menu/MenuComponent';
import { BrowserRouter as Router } from 'react-router-dom';

const { Header, Footer } = Layout;
const { Text } = Typography;

export const TournamentContext = React.createContext({
  tournamentCompleted: false,
  bonusCompleted: false
});

export const App: FC = () => {
  const [menuVisible, setMenuVisible] = useState<boolean>(false)
  const tournamentContext = useContext(TournamentContext)

  return (
    <Router>
      <Layout>
        <Header>
          <Row align="middle" gutter={[24, 24]}>
            <Image src={process.env.PUBLIC_URL + "/logo500.png"} preview={false} style={{ width: 48, height: 48, marginRight: 12, marginLeft: -24 }} onClick={(e) => setMenuVisible(true)} />
            <Text strong style={{ color: COYOTE_ORANGE }} className="headerText">ObiWannCoyote's PUBG Tournament</Text>
          </Row>
        </Header>
        <Main />
        <Footer style={{ backgroundColor: "#1A1A1A", position: "absolute", bottom: "0px", width: "100%" }} className="hiddenOnMobile">
          <Carousel style={{ width: "100%", marginLeft: "45%" }} effect='fade' dots={false} autoplay={true} autoplaySpeed={10000}>
            <div>
              <Image src={process.env.PUBLIC_URL + "/assets/madrinas-banner.png"} preview={false} height={20} 
                    onClick={() => window.open("https://madrinas.coffee/Coyote", "_blank")}/>
            </div>
            <div>
              <Text style={{ color: MURPLE_COLOR }}> ♥ Owned by Morg ♥</Text>
            </div>
          </Carousel>
        </Footer>
      </Layout>
      <Drawer visible={menuVisible} onClose={(e) => setMenuVisible(false)}>
        <MenuComponent completed={tournamentContext.tournamentCompleted} bonus={tournamentContext.bonusCompleted} />
      </Drawer>
    </Router>
  )
};

export default App;